import ChatService from '@/services/API/ChatService';
import UnitFaqService from '@/services/API/UnitFaq';

import { TASK_STATUSES } from '@/utils/constants';
import { appChat } from '@/plugins/app-chat';

import Base from '../Base';
import Lesson from './Lesson';
import Chat from './Chat';
import UnitFaq from './UnitFaq';

export default class Unit extends Base {
  constructor(item) {
    super(item.id, '/course-units');

    this.title = item.title;
    this.description = item.description;
    this.duration = item.duration;
    this.course_id = item.course_id;
    this.courses = item.courses;
    this.course_modules = item.course_modules;
    this.status = item.status;
    // relativeView = true - вывести прогресс обучающийся стороны, false - свой прогресс
    this.user_passed = item.relativeView ? item.complete_status : item.user_passed;
    this.chat_room = item.chat_room;
    // this.faq = item.faq.map((i) => new UnitFaq(i));
    this.faq = [];
    this.lessons = item.lessons
      ? item.lessons.map((i) => new Lesson({
        ...i,
        relativeView: item.relativeView,
        course_id: this.course_id,
      }))
      : [];

    this.tasks = item.tasks || [];
    this.created_at = item.created_at;

    // Есть ли новые сообщения по консультациям
    this.hasConsultationMessages = null;

    // Модуль к которому привязана тема
    [this.moduleItem] = item.course_modules || [];
  }

  async fetchUnread({ topConsultation, userId } = {}) {
    const tag = {
      course_id: this.course_id,
      course_unit_id: this.id,
    };
    // Только для консультации итоговой работы
    if (topConsultation) {
      tag.lesson_id = null;
    }
    const response = await ChatService.getUnreadConsultationsByTag(tag, userId);
    this.hasConsultationMessages = response.data.data;
  }

  async getFaq(params) {
    const extendParams = {
      ...params,
      'search[course_unit_id]': this.id,
      expand: 'answer,owner',
    };
    const response = await UnitFaqService.index(extendParams);
    this.faq = response.data.data.map((i) => new UnitFaq(i));
  }

  get tasksPassed() {
    return this.tasks
      .filter((t) => ![
        TASK_STATUSES.retake,
        TASK_STATUSES.notPassed,
        TASK_STATUSES.fail,
      ].includes(t.status));
  }

  get lessonsPassed() {
    return this.lessons.filter((i) => i.user_passed || i.complete_status);
  }

  get progress() {
    return (100 / this.lessons.length) * this.lessonsPassed.length;
  }

  get statusColor() {
    if (this.lessonsPassed.length > 0 || this.user_passed) {
      return this.user_passed ? 'success' : 'warning lighten-2';
    }
    return 'grey';
  }

  get isAllLessonsComplete() {
    return this.lessons.every(
      (lesson) => {
        const isFail = lesson.tasks.some((item) => [TASK_STATUSES.fail]
          .includes(item.status) && item.user_attempts + 1 === item.attempt);

        const allTaskDone = lesson.tasks
          .every((item) => ![
            TASK_STATUSES.retake,
            TASK_STATUSES.notPassed,
            TASK_STATUSES.inProcess,
            TASK_STATUSES.notChecked,
          ].includes(item.status));

        return lesson.user_passed && (!isFail && allTaskDone);
      },
    );
  }

  get isComplete() {
    if (this.tasks.length && this.tasks.some(
      (t) => [
        TASK_STATUSES.retake,
        TASK_STATUSES.fail,
        TASK_STATUSES.notPassed,
        TASK_STATUSES.inProcess,
      ].includes(t.status) && !t.exists_pass_task,
    )) return false;
    return this.isAllLessonsComplete;
  }

  get isFailed() {
    const statuses = this.tasks.map((i) => i.status);
    return statuses.includes(TASK_STATUSES.fail)
      && !(statuses.includes(TASK_STATUSES.retake)
      || statuses.includes(TASK_STATUSES.notPassed)
      || statuses.includes(TASK_STATUSES.inProcess));
  }

  isForbidden(units) {
    const idx = units.indexOf(this);
    return idx !== 0 && units[idx - 1].isPassed;
  }

  async openChatAsStudent() {
    const room = await ChatService.getRoomCourse(this.course_id);
    this.startChat({
      room: room.data.data,
      hideInitials: true,
    });
  }

  async openChatAsTeacher({ replyTo }) {
    this.startChat({
      room: this.chat_room,
      replyTo,
    });
  }

  async startChat({ room, hideInitials, replyTo }) {
    const tag = {
      course_id: this.course_id,
      course_unit_id: this.id,
    };
    const chat = new Chat({
      ...room,
      tag,
      hideInitials,
      replyTo,
    });
    appChat.set(chat, {
      opened: true,
      title: 'Консультация по теме',
      subtitle: this.title,
    });
    this.hasConsultationMessages = false;
  }
}
